import { defineStore } from 'pinia'
import Configuration from '@/model/Configuration'
import BusinessTimeBlockCollection from '@/model/business/BusinessTimeBlockCollection'

interface State {
  timeBlocks: BusinessTimeBlockCollection[]
  configuration: Configuration[]
}

/**
 * Store sa používa pre stravníka na objednanie stravy
 *
 * Vstupný komponent je OrdersTab.
 */
export const useBoarderFoodOrderStore = defineStore('BoarderFoodOrderStore', {

  state: (): State => ({
    timeBlocks: [],
    configuration: []
  }),

  getters: {
    /**
     * Zistí či v konfiguračných skupinách existuje nejaký link medzi TimeBlock a MenuGroup
     *
     * Link definuje zoznam skupín čo sa zobrazia pre daný TimeBlock. Skupiny čo nie sú v linku sa nezobrazia.
     */
    areTimeBlockLinkedToGroups(): boolean {
      return this.configuration.some((c: Configuration) => {
        let links = (c.settings as any).time_block_menu_group_link

        return links && Object.keys(links).length > 0
      });
    }
  },

  actions: {

  }

})
